import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { responsiveFont, HorizontalPadding, responsiveImageSize } from '../common/responsive.utils';
import ImageComponent from '../common/Image.component';
import ComponentImageWeb from '../../assets/images/main/web/component-02.png';
import ComponentImage02Mobile from '../../assets/images/main/mobile/component_02.png';

const MainWeb02Component = ({...props}) : React.ReactElement => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles(); 
    
    return (
        <>
            {isWeb ? (
                <>
                    <div style={styles.webComponent_Web}>
                        
                        <div style={{ height: 120 }} />
                        <div style={styles.webRowContainer01_Web}>

                            <div style={styles.webTextContainer01_Web}>

                                <div style={{ height: 170 }} />
                                <span style={styles.webSemiTitleText_Web}>
                                    반려인을 돕는 이웃
                                </span>

                                <div style={{ height: 6 }} />
                                <span style={styles.webTitleText_Web}>
                                    우리 동네 돌봄 이웃에게<br />
                                    도움 받아보기
                                </span>

                                <div style={{ height: 12 }} />
                                <span style={styles.webContentText_Web}>
                                    반려동물을 키우다 누군가의 도움이 필요할 때,<br />
                                    <span style={styles.webContentBoldText_Web} >돌봄∙산책</span>을 부탁할 이웃을 찾아보세요.
                                </span>
                            </div>

                            <ImageComponent
                                src={ComponentImageWeb}
                                alt="컴포넌트 이미지"
                                style={styles.webImage02_Web}
                            />
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div style={styles.component_Mobile}>

                        <div style={{ height: 50 }} />
                        <div style={styles.textContainer01_Mobile}>

                            <span style={styles.semiTitleText_Mobile} >
                                반려인을 돕는 이웃
                            </span>

                            <div style={{ height: 6 }} />
                            <span style={styles.titleText_Mobile} >
                                우리 동네 돌봄 이웃에게<br />
                                도움 받아보기
                            </span>

                            <div style={{ height: 12 }} />
                            <span style={styles.contentText_Mobile}>
                                반려동물을 키우다 누군가의 도움이 필요할 때,<br />
                                <span style={styles.contentBoldText_Mobile} >돌봄∙산책</span>을 부탁할 이웃을 찾아보세요.
                            </span>
                        </div>

                        <div style={{ height: 37 }} />
                        <div style={{ display: "flex", justifyContent:"center" }} >
                            <img
                                src={ComponentImage02Mobile}
                                style={styles.componentImage02_Mobile}
                                alt="imageComponent"
                            />
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    webComponent_Web: { width: "100vw", display: "flex", flexDirection: "column", backgroundColor: "white", alignItems: "flex-start", justifyContent: "flex-start", boxSizing: "border-box", paddingLeft: HorizontalPadding(24,88), paddingRight: 0,},
    webRowContainer01_Web: {width:"100%", display:"flex", flexDirection:"row", alignItems:"flex-start", justifyContent:"space-between", padding:"0px", margin:"0px"},
    webTextContainer01_Web: {display:"flex", flexDirection:"column", justifyContent:"flex-start", alignItems:"flex-start"},
    webSemiTitleText_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(16,26), lineHeight:"140%", fontWeight:"700", letterSpacing:"-0.01em", textAlign:"left", textUnderlinePosition:"from-font", textDecorationSkipInk:"none", color:"#9F6BFF", padding:"0", margin:"0"},
    webTitleText_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(22, 40), lineHeight:"140%", fontWeight:"700", letterSpacing:"-0.03em", textAlign:"left",textUnderlinePosition:"from-font", textDecorationSkipInk:"none", padding:"0", margin:"0" },
    webContentText_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(14, 24), lineHeight:"140%", fontWeight:"400", letterSpacing:"-0.03em", textAlign:"left", textUnderlinePosition:"from-font", textDecorationSkipInk:"none", padding:"0", margin:"0" , color:"#62686D"},
    webContentBoldText_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(14, 24), lineHeight:"140%", fontWeight:"700", letterSpacing:"-0.03em", textAlign:"left", textUnderlinePosition:"from-font", textDecorationSkipInk:"none", padding:"0", margin:"0" },
    webImage02_Web: { width: responsiveImageSize(320, 800), height: responsiveImageSize(320,800), boxSizing:"border-box", margin:"0", padding:"0"},

    component_Mobile: { width: "100%", minWidth:"320px", display: "flex", flexDirection: "column", backgroundColor: "white",  },
    textContainer01_Mobile: { display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", paddingLeft: HorizontalPadding(24, 88), paddingRight: HorizontalPadding(24,88), },
    semiTitleText_Mobile: { fontFamily: "Pretendard", fontSize: responsiveFont(16, 26), lineHeight: "140%", fontWeight: "700", letterSpacing: "-0.01em", textAlign: "left", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", padding: 0, margin: 0, color: "#9F6BFF" },
    titleText_Mobile: { fontFamily: "Pretendard", fontSize: responsiveFont(22, 40), lineHeight:"140%", fontWeight: "700", letterSpacing: "-0.03em", textAlign: "left", padding: 0, margin: 0, textUnderlinePosition: "from-font", textDecorationSkipInk: "none" },
    contentText_Mobile: { fontFamily: "Pretendard", fontSize: responsiveFont(14, 24), lineHeight:"140%", fontWeight: "400", letterSpacing: "-0.03em", textAlign: "left", padding: 0, margin: 0, textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#62686D" },
    contentBoldText_Mobile: { fontFamily: "Pretendard", fontSize: responsiveFont(14, 24), lineHeight: "140%", fontWeight: "700", letterSpacing: "-0.03em", textAlign: "left", padding: 0, margin: 0, textUnderlinePosition: "from-font", textDecorationSkipInk: "none", },
    componentImage02_Mobile: { width: responsiveImageSize(320, 800), height: responsiveImageSize(320, 800) },
});

export default MainWeb02Component